import Heading from "components/ui/Heading"
import DarkSection from "components/ui/Layout/DarkSection"

function OurServiceSection() {
  return (
    <DarkSection className="pb-24 pt-20">
      <Heading
        label="Our Service"
        title="Fully managed Apache Superset™ in your cloud"
        decoration="border"
        inverted
      />
      <div className="mt-16 grid grid-cols-1 gap-x-8 gap-y-4 lg:grid-cols-3">
        <List title="Monitor">
          <ListItem>Content permission, roles, and access</ListItem>
          <ListItem>Access and audit logs</ListItem>
          <ListItem>Backups and uptime for Preset Metadata DB</ListItem>
          <ListItem>Performance SLAs</ListItem>
          <ListItem>Disaster recovery (same SLAs as Preset)</ListItem>
        </List>
        <List title="Ease of Use">
          <ListItem>Configure</ListItem>
          <ListItem>Compute and resize for load</ListItem>
          <ListItem>
            Manage user access for data visualizations (RBAC, RLS)
          </ListItem>
          <ListItem>Install and manage patches/drivers</ListItem>
          <ListItem>Scale for load</ListItem>
        </List>
        <div className="space-y-4">
          <List title="Deploy">
            <ListItem>Control the routing in your network</ListItem>
            <ListItem>Manage cloud permissions granularly</ListItem>
          </List>
          <List title="Troubleshooting and Support">
            <ListItem>Get enterprise-grade support</ListItem>
          </List>
        </div>
      </div>
    </DarkSection>
  )
}

function List({ title, children }) {
  return (
    <div>
      <h4 className="text-2xl font-bold text-white">{title}</h4>
      <ul className="ml-7 mt-3 space-y-1">{children}</ul>
    </div>
  )
}

function ListItem({ children }) {
  return (
    <li className="flex text-base text-sage before:mr-4 before:mt-2 before:block before:h-2 before:w-2 before:rounded-full before:bg-lush before:content-['']">
      {children}
    </li>
  )
}

export default OurServiceSection
